module.exports = __webpack_public_path__ + "img/公共服务.2fdb30fe.png";